import React from "react";

const Announcements = () => {
  const researchItems = [
    {
      title:
        "Introducing the Chorus One Earn Widget: Rewards Made Simple for FinTech Apps and Platforms",
      description:
        "At Chorus One, we’ve always believed that staking should be both secure and seamless. Over the past few years, we’ve partnered with leading institutions like Ledger, Utila, and Cactus to bring institutional-grade staking solutions to users worldwide. These partnerships have largely relied on SDK-based integrations, which, while effective, still require a fair amount of development and testing on the client side. Now, we’re taking simplicity to the next level with the Chorus One Earn Widget.",
    },
    {
      title:
        "Treasury 3.0: How ReStaking and DeFi Will Unlock a New Era of On-Chain Capital Efficiency",
      description:
        "Institutional crypto treasuries are entering a new phase. In the first wave, treasurers allocated to Bitcoin and Ethereum, focusing on long-term exposure and basic staking yields. But as on-chain infrastructure matures and liquid staking protocols like Lido and EigenLayer gain traction, a new strategy is emerging: yield stacking. By combining liquid staking tokens (LSTs), restaking mechanisms, and DeFi services, treasuries can now layer multiple sources of yield on top of the same principal, without giving up custody, transparency, or compliance controls. Treasuries that can generate 3–5% from vanilla savings and staking, can now see 6–10% using enterprise-grade tools and increasingly permissioned crypto vaults. This is Treasury 3.0: dynamic, composable, and built for capital efficiency.",
    },
    {
      title: "The Future of ETF Staking and Multi-Yield Protocols",
      description:
        "The U.S. crypto ETF landscape is undergoing a transformative shift. The recent approval (or more accurately, no disapproval) of the REX-Osprey™ SOL + Staking ETF (ticker: SSK) marks a significant milestone, offering investors exposure to Solana (SOL) while earning yield through on-chain staking. This development signals a broader trend: the integration of staking rewards into regulated investment vehicles.",
      highlight: true,
    },
  ];
  return (
    <section className="px-6 py-20 text-gray-900 bg-white md:px-16 lg:px-28">
      <div className="mx-auto max-w-7xl">
        {/* Section Title */}

        <h2 className="text-[43px] font-medium leading-[50px] text-center text-transparent bg-clip-text bg-gradient-to-r from-[#102E31] to-[#157D87] md:text-[88px] md:text-left md:leading-[100px]">
          Recent <br /> Announcements
        </h2>

        {/* Research Grid */}
        <div className="grid gap-10 mt-10 md:grid-cols-3">
          {researchItems.map((item, index) => (
            <div
              key={index}
              className={`border-t pt-5 ${
                item.highlight ? "border-black" : "border-gray-500"
              }`}
            >
              <h3 className="mb-3 text-2xl font-semibold">{item.title}</h3>
              <p className="text-base leading-relaxed text-gray-700">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="flex justify-center mt-14">
          <div>
            <p
              href="#"
              className="flex items-center justify-center py-1 pl-2 pr-4 font-medium text-white transition bg-black rounded-full hover:bg-teal-800"
            >
              <span className="px-3 py-2 mr-2 text-xl text-black bg-white border border-black rounded-full">
                →
              </span>
              View All Posts
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Announcements;
